import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useEffect } from 'react';
// Visible-error beacon (2026-10-01): the LoadError banner owns reporting for
// unit-scoped /home/* fetch failures (the api.ts interceptor skips /home/*
// so the same failure is never reported twice). Fire-and-forget, session-deduped.
import { beaconVisibleError } from '../lib/homeBeacons';

// Shared unit-scoped page states (Jaime 2026-09-30 unit-selection lane).
// Spanish copy; empty-state vs error-state stay distinct: pages render the
// prompt while no unit is resolved, and LoadError instead of a bare empty
// list whenever the unit-scoped fetch fails.

const card = 'rounded-xl border border-[var(--v-border-light)] bg-[var(--v-surface-1)] p-6 text-center';

export function UnitPrompt() {
  return (
    <div className={card}>
      <p className="text-4xl">🏠</p>
      <p className="mt-2 font-semibold text-[var(--v-text-primary)]">Selecciona una unidad</p>
      <p className="mt-1 text-sm text-[var(--v-text-secondary)]">
        Elige una unidad en el selector de contexto para ver esta sección.
      </p>
    </div>
  );
}

export function LoadError({ message, onRetry }: { message: string; onRetry: () => void }) {
  useEffect(() => {
    beaconVisibleError({
      route: typeof window !== 'undefined' ? window.location.pathname : '',
      message,
      unitId: (() => { try { return localStorage.getItem('vecindus_active_owned_unit'); } catch { return null; } })(),
    });
  }, [message]);
  return (
    <div className={`${card} border-[var(--v-danger)]`}>
      <div className="flex items-center justify-center gap-2 text-[var(--v-danger)]">
        <AlertTriangle className="h-5 w-5" />
        <p className="font-semibold">No se pudo cargar</p>
      </div>
      <p className="mt-1 text-sm text-[var(--v-text-secondary)]">{message}</p>
      <button
        onClick={onRetry}
        className="mx-auto mt-4 flex items-center gap-2 rounded-xl bg-[var(--v-teal-600)] px-4 py-2 text-sm font-semibold text-white"
      >
        <RefreshCw className="h-4 w-4" />
        Reintentar
      </button>
    </div>
  );
}
